import type { DadataSuggestion } from '@api/dadata';
import type { storeAddressT } from '@store/UserStore.type';

// Only `dadata`, `flat` and `fio` are read here, and dadata fields are accessed
// loosely. Accept any address-like shape (e.g. cart.dadata, which carries a
// slightly different selection than people addresses) instead of strict storeAddressT.
type AddressStringInput = Partial<Omit<storeAddressT, 'dadata'>> & {
  dadata?: Record<string, unknown> | null;
};

export const createAddressString = (
  address?: AddressStringInput,
  withFlat?: boolean,
  withName?: boolean,
  shortFlat?: boolean
): string => {
  if (!address?.dadata) {
    return '';
  }

  const config = [
    // {
    //   name: 'cityType',
    //   postfix: '.'
    // },
    {
      name: 'city',
      postfix: ','
    },
    {
      name: 'areaType',
      postfix: '.'
    },
    {
      name: 'area',
      postfix: ','
    },
    {
      name: 'settlementType',
      postfix: '.'
    },
    {
      name: 'settlement',
      postfix: ','
    },
    {
      name: 'streetType',
      postfix: '.'
    },
    {
      name: 'street',
      postfix: ','
    },
    {
      name: 'houseType',
      postfix: '.'
    },
    {
      name: 'house',
      postfix: ','
    },
    {
      name: 'blockType',
      postfix: '.'
    },
    {
      name: 'block',
      postfix: ','
    }
  ];

  const sourceAddress: string[] = [];

  config.forEach(param => {
    const item = address?.dadata?.[param.name] as unknown as string;

    if (typeof item === 'undefined' || item == null || item.length === 0) {
      return;
    }

    sourceAddress.push(item + (param.postfix || ''));
  });

  let createdString = sourceAddress.join(' ');
  if (
    !!createdString.length &&
    createdString[createdString.length - 1] === ','
  ) {
    createdString = createdString.substring(0, createdString.length - 1);
  }

  if (withFlat && address.flat) {
    createdString += `, ${address.flat}`;

    if (createdString.length > 150 && shortFlat) {
      createdString = createdString.slice(0, 149) + '...';
    }
  }

  if (withName && address.fio) {
    createdString += `, ${address.fio}`;
  }

  return createdString;
};

const dadataStandartArray = [
  'fias_id',
  'geo_lat',
  'geo_lon',
  'fias_level',
  'kladr_id',
  'postal_code',
  'country',
  'region_fias_id',
  'region_kladr_id',
  'region_type',
  'region',
  'area_fias_id',
  'area_kladr_id',
  'area_type',
  'area',
  'city_fias_id',
  'city_kladr_id',
  'city_type',
  'city',
  'city_area',
  'city_district_fias_id',
  'city_district_type',
  'city_district',
  'settlement_fias_id',
  'settlement_kladr_id',
  'settlement_type',
  'settlement',
  'street_fias_id',
  'street_kladr_id',
  'street_type',
  'street',
  'house_fias_id',
  'house_kladr_id',
  'house_type',
  'house',
  'block_type',
  'block',
  'flat_type',
  'flat',
  'qc',
  'qc_geo',
  'beltway_hit',
  'beltway_distance',
  'raw_json',
  'federal_district',
  'region_with_type',
  'region_type_full',
  'area_with_type',
  'area_type_full',
  'city_with_type',
  'city_type_full',
  'city_district_kladr_id',
  'city_district_with_type',
  'city_district_type_full',
  'settlement_with_type',
  'settlement_type_full',
  'street_with_type',
  'street_type_full',
  'house_type_full',
  'block_type_full',
  'flat_type_full',
  'flat_area',
  'square_meter_price',
  'flat_price',
  'postal_box',
  'fias_code',
  'fias_actuality_state',
  'geoname_id',
  'capital_marker',
  'okato',
  'oktmo',
  'tax_office',
  'tax_office_legal',
  'timezone',
  'metro',
  'qc_complete',
  'qc_house',
  'history_values',
  'unparsed_parts',
  'source',
  'country_iso_code',
  'region_iso_code'
];

export const creatStandartDadataObj = (
  dadata: DadataSuggestion['data']
): Record<string, string> => {
  const standartDada = {};
  dadataStandartArray.forEach(item => {
    standartDada[item] = dadata[item];
  });

  return standartDada;
};

export const parseAddressString = (address: string): string => {
  let parseAddress = address;
  const removing = ['Россия, ', 'Московская обл, '];

  removing.forEach(item => {
    if (parseAddress.includes(item)) {
      parseAddress = parseAddress.split(item).join('');
    }
  });

  return parseAddress;
};
